
export interface FaceliftPdfViewerProps {

  url: string;
}

export const FaceliftPdfViewer: React.FC<FaceliftPdfViewerProps> = ({ url }) => (
  <iframe
    src={url}
    width="100%"
    height="100%"
    title="Invoice PDF Viewer"
    style={{ border: 'none' }}
    loading="lazy"
  />
);